import React, { useEffect } from "react";

import { HTextarea, passParamsThrough } from "../../../validation/HForm";
import { maxLength } from "../../../helpers/data-constants";
import CharCount from "../CharCount/CharCount";

import "./custom-forms.scss";

const DecisionMakersInfoAdd = (props) => {
  const { decisionInfo, setValue, watch } = props;
  const decisionMakersInfoValue = watch("decisionMakersInfo");

  useEffect(() => {
      setValue("decisionMakersInfo", decisionInfo);
  }, [decisionInfo, setValue]);

  return passParamsThrough(
    <div className="form-row">
      <div className="form-row-item description fullwidth">
        <div className="form-element fullwidth">
          <div className="form-element-data textarea decisionMakersInfo">
            <HTextarea
              h="true"
              className="input"
              rows="4"
              cols="10"
              name="decisionMakersInfo"
              id="decisionMakersInfo"
            />
          </div>
          <CharCount
            value={decisionMakersInfoValue}
            maxLength={maxLength.SERVICE_INFORMATION_RISK}
          />
        </div>
      </div>
    </div>,
    props
  );
};

export default DecisionMakersInfoAdd;
